import { useState } from "react"
import { FaExclamationCircle } from "react-icons/fa"
import moment from "moment"
import { FullScreenLoadingCover, SelectDropdown } from "@prosolve/common-components-ui"
import useDataSessions from "../../dataHooks/useDataSessions"
import useSnackbar from "../../hooks/useSnackbar"

const options = [
  { value: "0", text: '8:00 AM' },
  { value: "30", text: '8:30 AM' },
  { value: "60", text: '9:00 AM' },
]

export default ({
  eventData,
  sessions,
  onUpdate
}) => {
  const {
    startDate
  } = eventData

  const daysToEvent = moment(startDate, 'YYYY-MM-DD').diff(moment(), 'days')
  const isTimeReadonly = (daysToEvent <= 7)

  const getInitialStartTimeOffset = () => {
    const startTime = moment(sessions?.[0]?.startTime, 'HH:mm:ss')
    const defaultOffset = moment(startTime).hour(8).minute(0).seconds(0).milliseconds(0)
    const offset = startTime.diff(defaultOffset, 'minutes')
    const isUseActualOffset = options.some(o => o.value === `${offset}`)
    return {
      isUseActualOffset,
      offset: `${isUseActualOffset ? offset : 30}`
    }
  }

  const [isLoading, setIsLoading] = useState()
  const [initialTimeOffset] = useState(() => getInitialStartTimeOffset())
  const [startTimeOffset, setStartTimeOffset] = useState(initialTimeOffset.offset)

  const { updateSessions } = useDataSessions()
  const { newMessage } = useSnackbar()

  const onStartTimeUpdate = async (startTimeOffsetParam) => {
    if (startTimeOffset !== startTimeOffsetParam) {
      setStartTimeOffset(startTimeOffsetParam)

      const newOffset = (startTimeOffsetParam - startTimeOffset)
      const sessionDataUpdates = sessions?.map(s => ({
        _id: s._id,
        startTime: moment(s.startTime, 'HH:mm:ss').add(newOffset, 'minutes').format("HH:mm:ss.SSS") + "Z",
        endTime: moment(s.endTime, 'HH:mm:ss').add(newOffset, 'minutes').format("HH:mm:ss.SSS") + "Z"
      }))

      await fetchUpdateSessions(...sessionDataUpdates)
      newMessage({ message: 'All sessions updated ', severity: 'success' })

      onUpdate()
    }
  }
  
  const fetchUpdateSessions = async (...sessionData) => {
    setIsLoading(sessionData)
    try {
      await updateSessions(sessionData)
    } catch (e) {
      console.log(e)
      newMessage({ message: 'Save failed', severity: 'failure' })
    }
    setIsLoading()
  }

  return (
    !isTimeReadonly &&
      <>
        <div>Start Time:</div>
        <SelectDropdown 
          id={'startTimeOffset'}
          value={startTimeOffset}
          width={200}
          options={options}
          onChange={onStartTimeUpdate}
        />
        {!initialTimeOffset.isUseActualOffset &&
          <span title={
            'The first session occurs outside the standard 8, 8:30, 9 AM options. The displayed start time may not reflect the actual event start, but it can still be used to shift all sessions by ±30 minutes.'
          } style={{ cursor: 'help' }}>
            <FaExclamationCircle />
          </span>
        }

        {isLoading &&
          <FullScreenLoadingCover />
        }
      </>
  )
}